module.exports = {
	"header.logo.title": "Aide à la décision GROHE Smart Control",
	"homepage.headline": "Aide à la décision GROHE Smart Control",
	"homepage.introtext": "Répondez à quelques questions ci-dessous pour trouver le système de douche GROHE SmartControl le plus adapté à vos besoins.",
	"homepage.buttonStart": "Démarrez",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": " https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": " https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.copyright": "© 2017 GROHE N.V.-S.A.",
	"configurator.button.seeResults": "Voir résultats",
	"question1.question": "Où souhaitez-vous prendre votre douche?",
	"question1.option1.text": "Espace de douche",
	"question1.option2.text": "Dans la baignoire",
	"question2.question": "Quel est le type que vous préférez ? Encastrable, à poser ou une combinaison des deux?",
	"question2.option1.text": "Mitigeur thermostatique et douche installés apparents",
	"question2.option2.text": "Mitigeur thermostatique installé apparent, mais avec douche encastrée",
	"question2.option3.text": "Totalement encastré",
	"question3.question": "Où souhaitez-vous prendre votre douche?",
	"question3.option1.text": "Avec le thermostatique  SmartControl",
	"question3.option2.text": "Avec un mitigeur thermostatique",
	"question3.option3.text": "Mitigeur monocommande douche",
	"question3.option4.text": "Inverseur manuel (sur un système de douche déjà existant)",
	"question4.question": "Que souhaitez-vous contrôler avec votre douche?",
	"question4.option1.text": "Uniquement la douchette à main",
	"question4.option2.text": "Une large douche de tête (150-250mm) et une douchette à main",
	"question4.option3.text": "Une douche de tête extra large (250-400mm) et une douchette à main",
	"question4.option4.text": "Une large douche de tête (150-250mm), une douchette à main et vidage baignoire",
	"question4.option5.text": "Une douche de tête extra large (250-400mm), une douchette à main et vidage baignoire",
	"question5.question": "Quelle est la forme que vous préférez?",
	"question5.option1.text": "Carré",
	"question5.option2.text": "Rond",
	"question6.question": "De combien de boutons de commande SmartControl avez-vous besoin?",
	"question6.option1.text": "Trois : douche de tête avec 2 types de jets et douchette",
	"question6.option2.text": "Trois : douche de tête avec 2 types de jets et bec de baignoire",
	"question6.option3.text": "Trois : douche de tête, douchette en bec de baignoire",
	"question6.option4.text": "Trois : douche de tête, douche latérale et douchette",
	"question6.option5.text": "Deux : douche de tête et douchette",
	"question6.option6.text": "Deux : douchette et bec de baignoire",
	"question6.option7.text": "Un : uniquement douchette",
	"question6.option8.text": "Un : bec de baignoire",
	"question7.question": "Choisissez votre couleur?",
	"question7.option1.text": "Chromée",
	"question7.option2.text": "Blanc/Chromée",
	"question7.option3.text": "Blanc/Chromée",
	"question8.question": " Voulez-vous un panneau de commande avec support pour douchette intégré?",
	"question8.option1.text": "Oui, avec support pour douchette intégré",
	"question8.option2.text": "Non, j'achète un support pour douchette séparément",
	"question9.question": "Voulez-vous une barre de douche ou un support mural avec la douchette?",
	"question9.option1.text": "Barre de douche",
	"question9.option2.text": "Support mural",
	"question10.question": "Voulez-vous une douche de tête montée sur le mur ou une douche de plafond?",
	"question10.option1.text": "Douche de tête montée sur le mur",
	"question10.option2.text": "Douche de plafond",
	"results.title": "{productGroupsCount, plural, \none {Votre résultat} \nother {Vos résultats}\n}",
	"results.bundle.title": "Pour une installation correcte, vous avez également besoin de:",
	"results.newConfiguration.buttonText": "Recommencez",
	"results.product.button.productInformation": "Informations produit",
	"results.product.button.dealerLocator": "Cherchez un point de vente",
	"results.product.button.buyNow": "Achetez en ligne",
	"results.product.information": "Informations produit",
	"results.product.dealer": "Cherchez un point de vente",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.newConfiguration.title": "Voulez-vous recommencer?",
	"results.product.number": "numéro d’article: #{number}",
	"results.product.button.downloadPDF": "Télécharger la proposition (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "404 Page introuvable",
	"404.link.goBack": "Retour à la page d’accueil"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.fr_be.json
// module id = 755
// module chunks = 0